module.exports = __webpack_public_path__ + "media/colis-deja-scanne.2bf4e5e3.mp3";